angular.module('dpw.services').factory('setUpAppService', ['api', '$q', function (api, $q) {
    var WEBHOOK_BASE_URL = 'https://hooks.ringcentral.com/webhook/v2';
    
    return {
        installMna: installMna,
        uninstallMna: uninstallMna
    };

    function installMna(appId, groupId) {
        return $q(function (resolve) {
            api.call(api.myAccount.glip.installMna({
                appId: appId,
                groupId: groupId
            }), function (data) {
                var token = _.get(data, 'glipIntegration.token');
                var integrationId = _.get(data, 'glipIntegration._id');
                var webhookUrl = WEBHOOK_BASE_URL + '/' + token;
                resolve({
                    webhookUrl: webhookUrl,
                    integrationId: integrationId
                });
            });
        });
    }

    function uninstallMna(appId, integrationId) {
        return $q(function (resolve) {
            api.call(api.myAccount.glip.uninstallMna({
                appId: appId,
                integrationId: integrationId,
                noLoading: true
            }), function () {
                resolve();
            }, function () {
                resolve();
            });
        });
    }
}]);
